<template>
  <div class="subuser-page-wrapper">
    <Breadcrumbs main="" title="Team Members" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
            <div class="subuser-page-header">
              <!-- Search Bar Row -->
              <b-row class="mb-3">
                <b-col md="4">
                  <div class="subuser-page-search-wrapper">
                    <b-input-group>
                      <b-input-group-prepend>
                        <span class="input-group-text search-icon">
                          <i class="icofont icofont-search-alt-2"></i>
                        </span>
                      </b-input-group-prepend>
                      <b-form-input
                        class="subuser-page-search-input"
                        v-model="filter"
                        placeholder="Search"
                        type="search"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col md="8" class="d-flex justify-content-end align-items-center">
                  <div class="subuser-page-per-page-wrapper">
                    <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span>Per page : </span>
                    <div class="select-wrapper">
                      <b-form-select
                        class="subuser-page-per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="getSubUsers"
                      >
                      </b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                  <button v-if="plan_details.plan_type == 1 || plan_details.plan_name == 'free'"
                    class="subuser-page-add-btn ml-3" @click="OpenUpdatePlan()">
                    <img src="@/assets/icons/add-subuser.svg" alt="Add User" class="add-subuser-icon" />
                    Add User
                  </button>
                  <button v-else class="subuser-page-add-btn ml-3" @click="add_sub_user = true">
                    <img src="@/assets/icons/add-subuser.svg" alt="Add User" class="add-subuser-icon" />
                    Add User
                  </button>
                  <add-monitor-button 
                    class="ml-3" 
                    :icon-only="true" 
                    variant="green"
                  />
                </b-col>
              </b-row>
            </div>
              <div class="col-md-12" v-if="loading">
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <div v-else class="subuser-page-table-container">
                <div class="table-content-wrapper">
                  <b-table
                    class="subuser-page-table"
                    show-empty
                    stacked="md"
                    :items="items"
                    :filter="filter"
                    :fields="tablefields"
                    :per-page="perPage"
                    @filtered="onFiltered"
                    borderless
                  >
                <template #cell(index)="data">
                  <span class="subuser-sr-number">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
                </template>

                <template #cell(username)="data">
                  <span>{{ data.item.username }}</span>
                </template>
                
                <template #cell(email)="data">
                  <span>{{ data.item.email }}</span>
                </template>
                
                <template #cell(isactive)="data">
                    <div class="status-toggle">
                        <label class="switch">
                        <input type="checkbox" :checked=data.item.isactive @change="statusUpdate(data.item,'isactive')">
                        <span class="slider round" :class="data.item.isactive ? 'active' : ''"></span>
                        </label>
                    </div>                 
                </template>
                
                <template #cell(access)="data">
                  <div class="access-dropdown-wrapper">
                    <div class="access-split-button" :class="getAccessClass(data.item.access)">
                      <div class="access-leading-button">
                        <span class="access-radio"></span>
                        <span class="access-text">{{ getAccessText(data.item.access) }}</span>
                      </div>
                      <div class="access-trailing-button" @click="toggleAccessDropdown(data.item._id, $event)">
                        <svg class="access-arrow" :class="{ 'rotated': showAccessDropdown === data.item._id }" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.5 7.33L11 14.11L16.5 7.33" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div v-if="showAccessDropdown === data.item._id" class="access-dropdown">
                      <div 
                        v-for="option in accessOptions" 
                        :key="option.value"
                        class="access-option"
                        :class="option.class"
                        @click="selectAccess(data, option.value)"
                      >
                        <span class="access-radio" :class="{ 'selected': data.item.access === option.value }"></span>
                        <span class="access-text">{{ option.text }}</span>
                      </div>
                    </div>
                  </div>
                </template>

                <template #cell(action)="data">
                  <div class="action-buttons">
                    <button class="action-btn" @click="deleteSubUser(data.item._id)" title="Delete">
                      <img src="@/assets/icons/delete-icon.svg" alt="Delete" class="action-icon" />
                    </button>
                    <button class="action-btn" @click="editSubUser(data.item)" title="Edit">
                      <img src="@/assets/icons/edit-icon.svg" alt="Edit" class="action-icon" />
                    </button>
                  </div>      
                </template>
                  </b-table>
                </div>
                <!-- Pagination Component -->
                <div class="pagination-wrapper">
                  <pagination-component
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount || totalRows"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
                </div>
              </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-subuser" size="lg" @hidden="closeModal()" title="" class="theme-modal custom-modal" v-model="add_sub_user" no-close-on-backdrop hide-footer>
      <template #modal-header>
        <div class="custom-modal-header">
          <h5 class="custom-modal-title">{{ edit_sub_user ? 'Edit Team Member' : 'Add Team Member' }}</h5>
          <button class="custom-modal-close" @click="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
        <div class="add-subuser-container">
            <form action="" @submit.prevent="AddUser()">
                <!-- User Name -->
                <div class="form-group">
                    <label class="form-label">User Name<span class="required">*</span></label>
                    <div class="custom-input-wrapper" :class="{ 'has-validation': isNameEntered }">
                        <b-form-input 
                            type="text" 
                            name="username" 
                            v-model="input.username" 
                            :state="null"  
                            @input="usernameValidate" 
                            placeholder="Enter username" 
                            maxlength="50" 
                            class="custom-form-input"
                            required>
                        </b-form-input>
                        <span v-if="isNameEntered" class="validation-icon">
                            <svg v-if="!fullname_err_text" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                    <b-form-invalid-feedback v-if="isNameEntered && fullname_err_text">{{ fullname_err_text }}</b-form-invalid-feedback>
                </div>

                <!-- Member Email -->
                <div class="form-group">
                    <label class="form-label">Member Email<span class="required">*</span></label>
                    <div class="custom-input-wrapper" :class="{ 'has-validation': isEmailEntered }">
                        <b-form-input 
                            type="email" 
                            name="email" 
                            v-model="input.email" 
                            placeholder="Enter email" 
                            maxlength="100" 
                            :state="null" 
                            @input="validateEmail" 
                            class="custom-form-input"
                            required>
                        </b-form-input>
                        <span v-if="isEmailEntered" class="validation-icon">
                            <svg v-if="!invalid_email_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                    <b-form-invalid-feedback v-if="isEmailEntered && invalid_email_message">{{ invalid_email_message }}</b-form-invalid-feedback>
                </div>

                <!-- Password -->
                <div class="form-group">
                    <label class="form-label">Password</label>
                    <div class="custom-input-wrapper password-wrapper" :class="{ 'has-validation': isPasswordEntered }">
                        <img src="../assets/images/icons/lock-icon.svg" class="input-icon" alt="lock" />
                        <b-form-input 
                            :type="showPassword ? 'text' : 'password'" 
                            id="subuser-password"
                            name="password" 
                            v-model="input.password" 
                            placeholder="Enter password" 
                            maxlength="25" 
                            :state="null" 
                            @input="" 
                            class="custom-form-input with-icon password-input">
                        </b-form-input>
                        <img 
                            v-if="showPassword && input.password"
                            src="../assets/fonts/feather/eye.svg"
                            class="password-toggle"
                            @click="togglePassword('subuser-password')"
                            title="hide password"
                            alt="hide password"
                        />
                        <img 
                            v-else-if="!showPassword && input.password"
                            src="../assets/images/icons/eye-closed.svg"
                            class="password-toggle"
                            @click="togglePassword('subuser-password')"
                            title="show password"
                            alt="show password"
                        />
                        <span v-if="false" class="validation-icon">
                            <svg v-if="!invalid_password_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                                <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                                <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                    <b-form-invalid-feedback v-if="false">{{ invalid_password_message }}</b-form-invalid-feedback>
                </div>

                <!-- Sub user Access -->
                <div class="form-group">
                    <label class="form-label">Sub user Access</label>
                    <div class="custom-input-wrapper">
                        <b-form-select
                            v-model="input.access"
                            :options="accessFormOptions"
                            class="custom-form-input access-select"
                            :class="getFormAccessClass(input.access)"
                        >
                        </b-form-select>
                        <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form-actions">
                    <button 
                        type="submit" 
                        class="submit-btn" 
                        :disabled="!canSubmit"
                        :class="{ 'disabled': !canSubmit }"
                    >
                        {{edit_sub_user?'Save Changes':'Add Team Member'}}
                    </button>
                </div>
            </form>
        </div>
    </b-modal>
 </div>
</template>


<script>
import SubUserController from "../../services/subUserController";
import AddMonitorButton from ".././components/addMonitorButton.vue";
import UserController from "../../services/userController";
import PaginationComponent from "../components/PaginationComponent.vue";
export default {
    name: 'SubUser',
    components:{AddMonitorButton, PaginationComponent},
    data(){
        return{
            input:{username:'', access: 0},
            add_sub_user:false,
            edit_sub_user: false,
            items:[],
            totalRows:0,
            filter:null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 50],
            tablefields: [
                          { key: "index", label: "Sr", sortable: false },
                          { key: "username", label: "Name", sortable: true },
                          { key: "email", label: "Email", sortable: true },
                          { key: "isactive", label: "Status", sortable: false },
                          { key: "access", label: "Access", sortable: false },
                          { key: "action", label: "Action", sortable: false },
                        ],
            loading: false,
            totalRowsCount: 0,
            fullname_err_text:'Username required',
            plan_details:{},
            btn_class:'',
            isNameEntered: false,
            isEmailEntered: false,
            invalid_email_message: 'Email required',
            invalid_password_message: '',
            isPasswordEntered: false,
            showAccessDropdown: null,
            currentDropdownButton: null,
            resizeTimeout: null,
            accessOptions: [
              { value: 0, text: 'Read', class: 'access-read' },
              { value: 1, text: 'Write', class: 'access-write' },
              { value: 2, text: 'Realm', class: 'access-realm' }
            ],
            accessFormOptions: [
              { value: 0, text: 'Read only' },
              { value: 1, text: 'Write' },
              { value: 2, text: 'Realm' }
            ],
            showPassword: false
        }
    },
    mounted(){
      if(this.$root.$data.plan_details == undefined){
        this.getPlanInfo();
      } else {
        this.plan_details = this.$root.$data.plan_details
      }
      this.getSubUsers()

      let pathName = this.$route.name
      if (pathName === 'Dashboard' || pathName === 'Incidents' || pathName === 'Referral' || pathName === 'Profile') {
          this.btn_class = 'custom-btn-dark';
      } else {
          this.btn_class = 'add-monitor-btn-green';
      }
      
      // Add click outside handler for access dropdown
      document.addEventListener('click', this.handleClickOutside);
      // Add scroll listener to close dropdown on scroll
      window.addEventListener('scroll', this.handleScroll, true);
      // Add resize listener to close dropdown on window resize
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleClickOutside);
      window.removeEventListener('scroll', this.handleScroll, true);
      window.removeEventListener('resize', this.handleResize);
    },
    computed:{
      canSubmit() {
        // Check if username is valid
        const isUsernameValid = this.input.username && 
                               this.input.username.trim() !== '' && 
                               !this.fullname_err_text;
        
        // Check if email is valid
        const isEmailValid = this.input.email && 
                            this.input.email.trim() !== '' && 
                            !this.invalid_email_message;
        
        // Password is optional for both new and edit modes
        
        return isUsernameValid && isEmailValid;
      }
    },
    methods:{
        async getSubUsers(txt){
            this.loading = true;
            this.items = []
            if(txt == 'next'){this.currentPage ++}
            if(txt == 'prev'){
              if(this.currentPage != 1){
              this.currentPage --
              }
            }
            let paginationQuery = '?currentPage='+this.currentPage+'&pageSize='+this.perPage
            
            let response = await SubUserController.getAll(paginationQuery)
            console.log('SubUser API Response:', response); // Debug log
            if (response.result || response.data) {
                this.items = response.data;
                this.totalRows = this.items.length;
                // Use the total count from API, or if not available, don't limit to current page items
                this.totalRowsCount = response.totalCount || response.total || response.count || 0;
                
                // If API doesn't return total count and we have a full page, assume there might be more
                if (!this.totalRowsCount && this.items.length === this.perPage) {
                    // Set a high number to enable next button
                    this.totalRowsCount = this.currentPage * this.perPage + 1;
                } else if (!this.totalRowsCount) {
                    // If less than perPage items, this is likely the last page
                    this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.items.length;
                }
            }
            this.loading = false;
        },
        handlePageChange(page) {
            if (page === 'next') {
                this.currentPage++;
            } else if (page === 'prev' && this.currentPage > 1) {
                this.currentPage--;
            }
            this.getSubUsers();
        },
        handlePerPageChange(value) {
            this.perPage = value;
            this.currentPage = 1;
            this.getSubUsers();
        },
        validateEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!regex.test(email)){
              this.$toasted.show('Invalid email', {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
              return false
            }
            return true;
          },
        async AddUser() {
          // The canSubmit computed property already validates everything
          // So we can proceed directly with submission
          var payload = {"username": this.input.username,"subUserEmail": this.input.email,"password": this.input.password,"access": this.input.access}
          var response
          if(this.edit_sub_user){
              var p =  {"username": this.input.username,"password": this.input.password,"email": this.input.email, "access": this.input.access}
              var e_payload = { "subUserId": this.input._id,"changePayload": p}
              response = await SubUserController.editSubUser(e_payload);
          }
          else{
              response = await SubUserController.CreatSubUser(payload);
          }
          
          if(response.result){
              this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
              this.add_sub_user = false;
              this.getSubUsers()
          }else{
              this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
          }
      },
      editSubUser(data){
          this.add_alers_modal = false
          this.add_sub_user = true
          this.input = data;
          this.edit_sub_user = true;

          if(this.edit_sub_user) {
            this.isNameEntered = true;
            this.fullname_err_text = '';  
            this.isEmailEntered = true;
            this.invalid_email_message = '';
          }
        },
     async deleteSubUser(id){
        if(confirm("Are you sure want to delete?")){
          let response = await SubUserController.deleteSubUser({"subUserId": id});
          if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            this.getSubUsers()
          }
          else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
            this.getSubUsers()
          }
        }
      },
        closeModal(){
          this.input={username:'', access: 0}
          this.add_sub_user = false
          this.edit_sub_user = false;
          
          this.isNameEntered = null;
          this.fullname_err_text = '';  
          this.isEmailEntered = null;
          this.invalid_email_message = '';
          this.isPasswordEntered = null;
          this.invalid_password_message = '';
          this.showPassword = false;

          this.getSubUsers();
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async statusUpdate(data,txt){
        var payload
        var s = true
        var toastMessage = ''
        switch(txt){
            case 'isactive':
                if(data.isactive == true){
                        s = false
                    }
                    if (data.isactive == false) {
                    data.isactive = true;
                    } else {
                    data.isactive = false;
                    }
                    payload = {"subUserId": data._id, "changePayload": {"isactive":s}}
                break;
        }
        let response = await SubUserController.editSubUser(payload)
        if(response.result){
            this.$toasted.show(toastMessage || response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        }
        else{
          this.getSubUsers()
          this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
        }
      },
      async accessUpdate(data, txt) {
        var payload = {"subUserId": data.item._id, "changePayload": {"access": txt}}
        let response = await SubUserController.editSubUser(payload)
        if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        }
        else{
          this.getSubUsers()
          this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
        }
      },
      openOtpModal(data){
        this.otp_data = []
        this.otp_data = data
      },
      async copyUrl(txt){
        try {
          if (navigator.clipboard && window.isSecureContext) {
            // Use modern Clipboard API if available
            await navigator.clipboard.writeText(txt);
          } else {
            // Fallback for older browsers
            const el = document.createElement('textarea');
            el.addEventListener('focusin', e => e.stopPropagation());
            el.value = txt;
            el.style.position = 'fixed';
            el.style.opacity = '0';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
          }
          this.$toasted.show('URL copied to clipboard.', {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        } catch (err) {
          this.$toasted.show('Failed to copy URL', {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
        }
      },
      usernameValidate(username) {
        this.isNameEntered = true;
        username = username ? username : this.input.username;

        let regexp = /^(?!\s*$)[a-zA-Z0-9 ._-]+$/;

        if (username === "") {
          this.fullname_err_text = "Username required";
          return false;
        } else if (username.length > 50) {
          this.fullname_err_text = "Username cannot exceed 50 characters";
          return false;
        } else if (!regexp.test(username)) {
          this.fullname_err_text = "Username can only contain alphanumeric characters and spaces";
          return false;
        } else {
          this.fullname_err_text = "";
          return true;
        }
      },
      validateEmail (email) {
        this.isEmailEntered = true;
        email = email ? email : this.input.email;

        let regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(regexp.test(email)){
          this.invalid_email_message = '';
          return true;
        } else {
          this.invalid_email_message = 'Please enter a valid email';
          return false;
        }
      },
      validatePassword(password) {
        // Password validation removed
        return true;
      },
      OpenUpdatePlan(){
        this.$toasted.show('Please Upgrade your plan.', {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
        var el = document.querySelector('#upgrade_btn');
        if(el){
          el.click()
        }    
      },
      async getPlanInfo() {
        let response = await UserController.getPlanInfo();
        if (response.result) {
          this.plan_details = response.message;
          this.$root.$data.plan_details = this.plan_details
        }
      },
      getAccessClass(access) {
        switch(access) {
          case 0: return 'access-read';
          case 1: return 'access-write';
          case 2: return 'access-realm';
          default: return 'access-read';
        }
      },
      getAccessText(access) {
        const option = this.accessOptions.find(opt => opt.value === access);
        return option ? option.text : 'Read';
      },
      toggleAccessDropdown(userId, event) {
        if (this.showAccessDropdown === userId) {
          this.showAccessDropdown = null;
          this.currentDropdownButton = null;
        } else {
          this.showAccessDropdown = userId;
          this.currentDropdownButton = event.currentTarget.parentElement;
          // Position dropdown using fixed positioning
          this.$nextTick(() => {
            this.positionDropdown();
          });
        }
      },
      positionDropdown() {
        if (!this.currentDropdownButton || !this.showAccessDropdown) return;
        
        // Find the dropdown for the current row
        const dropdownWrapper = this.currentDropdownButton.closest('.access-dropdown-wrapper');
        const dropdown = dropdownWrapper ? dropdownWrapper.querySelector('.access-dropdown') : null;
        
        if (dropdown) {
          const buttonRect = this.currentDropdownButton.getBoundingClientRect();
          const dropdownHeight = 116; // Height for 3 options (36px each + padding)
          
          // Check viewport boundaries
          const viewportHeight = window.innerHeight;
          const spaceToViewportBottom = viewportHeight - buttonRect.bottom;
          
          // Position dropdown using fixed positioning
          dropdown.style.left = buttonRect.left + 'px';
          dropdown.style.width = Math.max(150, buttonRect.width) + 'px';
          
          // Simple logic: if not enough space below, open upward
          if (spaceToViewportBottom < dropdownHeight + 20) {
            // Open upward
            dropdown.classList.add('dropup');
            dropdown.style.bottom = (viewportHeight - buttonRect.top + 4) + 'px';
            dropdown.style.top = 'auto';
          } else {
            // Open downward
            dropdown.classList.remove('dropup');
            dropdown.style.top = (buttonRect.bottom + 4) + 'px';
            dropdown.style.bottom = 'auto';
          }
        }
      },
      selectAccess(data, value) {
        data.item.access = value;
        this.showAccessDropdown = null;
        this.currentDropdownButton = null;
        this.accessUpdate(data, value);
      },
      handleClickOutside(event) {
        if (!event.target.closest('.access-dropdown-wrapper')) {
          this.showAccessDropdown = null;
          this.currentDropdownButton = null;
        }
      },
      handleScroll() {
        // Close dropdown on scroll
        this.showAccessDropdown = null;
        this.currentDropdownButton = null;
      },
      handleResize() {
        // Debounce resize event to avoid excessive updates
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          if (this.showAccessDropdown && this.currentDropdownButton) {
            // Reposition dropdown instead of closing it
            this.positionDropdown();
          }
        }, 100);
      },
      togglePassword(id){
        const password = document.getElementById(id);
        this.showPassword = this.showPassword === false ? true: false
        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);
      },
      getFormAccessClass(access) {
        switch(access) {
          case 0: return 'form-access-read';
          case 1: return 'form-access-write';
          case 2: return 'form-access-realm';
          default: return 'form-access-read';
        }
      }
    }
}

</script>

<style scoped>
/* Main wrapper */
.subuser-page-wrapper {
  padding: 0;
}

/* Header styling */
.subuser-page-header {
  margin-bottom: 20px;
  margin-top: 30px;
  width: 100%;
}

/* Search input styling */
.subuser-page-search-wrapper {
  position: relative;
}

.subuser-page-search-wrapper .input-group {
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  padding: 0px;
}

.subuser-page-search-wrapper .input-group-text {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px;
}

.subuser-page-search-wrapper .search-icon {
  color: #344054;
  font-size: 18px;
}

.subuser-page-search-input {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px 3px 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #111827;
}

.subuser-page-search-input:focus {
  box-shadow: none;
  background: transparent;
}

.subuser-page-search-input::placeholder {
  color: #9CA3AF;
}

/* Per page selector styling */
.subuser-page-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 47px;
}

.subuser-page-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.subuser-page-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.subuser-page-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.subuser-page-per-page-select:focus {
  box-shadow: none;
  outline: none;
}

.subuser-page-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

/* Add User button */
.subuser-page-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background: #2FB234;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 48px;
}

.subuser-page-add-btn:hover {
  background: #28A22C;
}

.add-subuser-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

/* Table container */
.subuser-page-table-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  overflow: hidden;
  margin: 0 0 20px 0;
  width: 100%;
  position: relative;
}

/* Table content wrapper to handle overflow while keeping dropdown visible */
.table-content-wrapper {
  position: relative;
  overflow: visible;
  border-radius: 20px 20px 0 0;
}

/* Table styling */
.subuser-page-table {
  margin-bottom: 0;
  width: 100%;
  border: none !important;
  border-radius: 20px !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: visible;
}

/* Ensure table content respects the rounded corners */
.subuser-page-table >>> thead tr:first-child th:first-child {
  border-top-left-radius: 20px;
}

.subuser-page-table >>> thead tr:first-child th:last-child {
  border-top-right-radius: 20px;
}

.subuser-page-table >>> tbody tr:last-child td:first-child {
  border-bottom-left-radius: 20px;
}

.subuser-page-table >>> tbody tr:last-child td:last-child {
  border-bottom-right-radius: 20px;
}

/* Remove bottom border from last row */
.subuser-page-table >>> tbody tr:last-child td {
  border-bottom: none !important;
}

.subuser-page-table >>> thead th {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px!important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

/* Center align the Action column header */
.subuser-page-table >>> thead th:last-child {
  text-align: center !important;
}

.subuser-page-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #161616;
  vertical-align: middle;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
  position: relative;
  overflow: visible;
}

/* Serial number */
.subuser-sr-number {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}

/* Status toggle */
.status-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 75%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 24px;
  background-color: #E5E7EB;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #10B981;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Access Dropdown */
.access-dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.access-split-button {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 36px;
  border-radius: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: white;
  transition: all 0.2s ease;
}

.access-split-button.access-read {
  background: #158DF7;
}

.access-split-button.access-write {
  background: #F78E15;
}

.access-split-button.access-realm {
  background: #2FB234;
}

.access-leading-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 10px 10px 12px;
  height: 32px;
  border-radius: 16px 4px 4px 16px;
  background: inherit;
}

.access-trailing-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 32px;
  padding: 5px 14px 5px 12px;
  border-radius: 4px 16px 16px 4px;
  background: inherit;
  cursor: pointer;
  position: relative;
}

.access-trailing-button::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 20px;
  background: rgb(255, 255, 255);
}

.access-trailing-button:hover {
  background: rgba(0, 0, 0, 0.1);
}

.access-radio {
  width: 20px;
  height: 20px;
  border: 2px solid white;
  border-radius: 50%;
  background: transparent;
  position: relative;
  flex-shrink: 0;
}

.access-radio::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

.access-text {
  line-height: 20px;
  letter-spacing: 0.01em;
}

.access-arrow {
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.access-arrow.rotated {
  transform: rotate(180deg);
}

/* Access Dropdown Menu */
.access-dropdown {
  position: fixed;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 99999 !important;
  min-width: 150px;
  overflow: hidden;
  padding: 4px;
}

/* Dropdown positioning is handled by JavaScript */

.access-option {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 10px 10px 12px;
  margin-bottom: 2px;
  border-radius: 12px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: white;
  transition: all 0.2s ease;
  height: 36px;
}

.access-option:last-child {
  margin-bottom: 0;
}

.access-option.access-read {
  background: #158DF7;
}

.access-option.access-write {
  background: #F78E15;
}

.access-option.access-realm {
  background: #2FB234;
}

.access-option:hover {
  filter: brightness(0.9);
}

.access-option .access-radio {
  width: 20px;
  height: 20px;
  border: 2px solid white;
  border-radius: 50%;
  background: transparent;
  position: relative;
  flex-shrink: 0;
}

.access-option .access-radio.selected::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

/* Action buttons */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 4px;
  text-decoration: none;
}

.action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.action-icon {
  width: 20px;
  height: 20px;
}

/* Pagination wrapper */
.subuser-page-table-container .pagination-wrapper {
  background: #FFFFFF;
  border-radius: 0 0 20px 20px;
  padding: 0;
  border-top: none !important;
}

/* Remove any top border from pagination component and its children */
.subuser-page-table-container .pagination-wrapper > *,
.subuser-page-table-container .pagination-wrapper .custom-pagination {
  border-top: none !important;
  margin-top: 0 !important;
}

/* Loader */
.loader-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Empty state */
.subuser-page-table .b-table-empty-row td {
  text-align: center;
  padding: 60px 20px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #6B7280;
}

/* Custom Modal Styles */
.custom-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.custom-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 26px;
  color: #3A3A3A;
  margin: 0;
  text-align: center;
}

.custom-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.custom-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.custom-modal .modal-body {
  padding: 30px;
  font-family: 'Poppins', sans-serif;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .subuser-page-header > .row > .col-md-4,
  .subuser-page-header > .row > .col-md-8 {
    margin-bottom: 16px;
  }

  .subuser-page-header .col-md-8 {
    flex-direction: column;
    align-items: stretch !important;
  }

  .subuser-page-per-page-wrapper {
    justify-content: center;
    margin-bottom: 12px;
  }

  .subuser-page-add-btn {
    width: 100%;
    justify-content: center;
  }

  .subuser-page-table tbody td {
    padding: 16px 20px;
    font-size: 14px;
  }

  .action-buttons {
    justify-content: flex-start;
  }
}

/* Add Subuser Form Styles */
.add-subuser-container {
  width: 100%;
}

/* Form Group */
.add-subuser-container .form-group {
  margin-bottom: 30px !important;
}

.add-subuser-container .form-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #3A3A3A;
  margin-bottom: 10px;
  margin-top: 8px;
  display: block;
}

.add-subuser-container .required {
  color: #E70000;
  margin-left: 2px;
}

/* Custom Input Wrapper */
.add-subuser-container .custom-input-wrapper {
  background: transparent;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 0 12px;
  height: 48px;
  display: flex;
  align-items: center;
  position: relative;
}

.add-subuser-container .custom-input-wrapper.password-wrapper {
  padding-left: 44px;
  padding-right: 50px;
}

.add-subuser-container .custom-input-wrapper.has-validation {
  padding-right: 40px;
}

/* Input Icons */
.add-subuser-container .input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.6;
}

/* Password Toggle */
.add-subuser-container .password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 20px;
  height: 20px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.add-subuser-container .password-toggle:hover {
  opacity: 1;
}

/* Custom Form Input */
.add-subuser-container .custom-form-input {
  border: none !important;
  background: transparent !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3A3A3A;
  padding: 0 !important;
  height: auto;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.add-subuser-container .custom-form-input.with-icon {
  padding-left: 15px !important;
}

.add-subuser-container .custom-form-input:focus {
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
  border: none !important;
}

.add-subuser-container .custom-form-input::placeholder {
  color: #3A3A3A;
  opacity: 0.5;
}

.add-subuser-container .password-input {
  padding-right: 40px !important;
}

/* Validation Icon */
.add-subuser-container .validation-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.add-subuser-container .validation-icon svg {
  width: 20px;
  height: 20px;
}

/* Select Icon */
.add-subuser-container .select-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #344054;
  font-size: 16px;
}

/* Custom Select Styling for Access Dropdown */
.add-subuser-container .custom-input-wrapper select.custom-form-input {
  color: #158DF7 !important;
  font-weight: 500;
  padding-left: 12px !important;
  padding-top: 2px !important;
  cursor: pointer;
}

.add-subuser-container .custom-input-wrapper select.custom-form-input option {
  color: #3A3A3A;
  padding: 8px 12px;
}

/* Form Actions */
.add-subuser-container .form-actions {
  display: flex;
  justify-content: center;
  padding-top: 0;
  margin-top: 40px;
}

/* Submit Button */
.add-subuser-container .submit-btn {
  background: #2FB234;
  border: none;
  border-radius: 12px;
  padding: 12px 40px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  height: 48px;
}

.add-subuser-container .submit-btn:hover:not(:disabled) {
  background: #28A02D;
  transform: translateY(-1px);
}

.add-subuser-container .submit-btn.disabled,
.add-subuser-container .submit-btn:disabled {
  background: #7D8699;
  cursor: not-allowed;
  opacity: 1;
  transform: none;
}

/* Invalid Feedback */
.add-subuser-container .invalid-feedback {
  display: none;
}

.add-subuser-container .invalid-feedback.d-block {
  display: block !important;
  color: #EF4444;
  font-size: 14px;
  margin-top: 6px;
}

/* Override Bootstrap default backgrounds */
.add-subuser-container .custom-input-wrapper .form-control {
  background-color: transparent !important;
  background-image: none !important;
}

/* Force transparent background on all form controls */
.add-subuser-container .custom-input-wrapper input.form-control,
.add-subuser-container .custom-input-wrapper input.form-control:focus,
.add-subuser-container .custom-input-wrapper input.form-control:active {
  background-color: transparent !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>